"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = _interopRequireDefault(require("./Icons"));

var _FullBar = _interopRequireDefault(require("./FullBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Modal = function Modal(props) {
  //render
  var modalClasses = (0, _classnames["default"])("modal-component", props.className, props.type, {
    "withSideMenu": props.sideMenu
  });
  var hasTopBar = props.topBarLeft || props.topBarMiddle || props.topBarRight; // Side Menu

  var sideMenu = props.sideMenu ? props.sideMenu.map(function (menuItem, index) {
    var itemClass = (0, _classnames["default"])("menuItem", menuItem.className, {
      "selected": menuItem.selected
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "menu-item-".concat(index),
      "data-value": menuItem.value,
      className: itemClass,
      onClick: menuItem.onClick
    }, /*#__PURE__*/_react["default"].createElement("p", null, menuItem.text), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rightContent"
    }, menuItem.iconContent != null ? /*#__PURE__*/_react["default"].createElement("p", {
      className: "mice"
    }, menuItem.iconContent) : /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "glyph-edit-alt",
      type: "glyph"
    })));
  }) : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: modalClasses,
    id: props.id
  }, hasTopBar && /*#__PURE__*/_react["default"].createElement(_FullBar["default"], {
    left: props.topBarLeft,
    middle: props.topBarMiddle,
    right: props.topBarRight
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modalContentContainer"
  }, sideMenu && /*#__PURE__*/_react["default"].createElement("div", {
    className: "sideMenuContainer"
  }, sideMenu), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modalContent"
  }, props.content, props.children)), props.backButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: "fixedBackButton",
    onClick: props.backButton
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    className: "fixedBackButton",
    name: "glyph-arrow-head",
    type: 'framed-glyph-ext-1'
  })));
};

Modal.propTypes = {
  id: _propTypes["default"].string,
  topBarLeft: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  topBarMiddle: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  topBarRight: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  type: _propTypes["default"].oneOf(["", "ext-1"]),
  sideMenu: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    iconContent: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].number]),
    selected: _propTypes["default"].bool,
    value: _propTypes["default"].string,
    className: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })),
  backButton: _propTypes["default"].func,
  content: _propTypes["default"].any,
  className: _propTypes["default"].string
};
Modal.defaultProps = {
  backButton: null,
  id: "",
  type: ""
};
var _default = Modal;
exports["default"] = _default;